__turbopack_context__.v({
  "blur": "index-module__sKj96W__blur",
  "userMenu": "index-module__sKj96W__userMenu",
});
